<template>
  <div class="scroll-y custom-scrollbar">
    <ion-row>
      <ion-col size="12" size-sm="10" offset-sm="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
        <div class="padding">
          <h1 class="text-center">Zasady</h1>
          <div v-if="loading" class="pd-20 text-center" style="width: 100%"><span class="loader red"></span></div>
          <div class="rte" v-html="rte"></div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</template>

<script>
import api from '@/services/Api';

export default {
  name: 'RulesIndex',
  data() {
    return {
      loading: false,
      rte: ''
    }
  },
  mounted() {
    this.getRules()
  },
  methods: {
    getRules() {
      this.loading = true;
      api.get('/api/v1/configuration/rules_text').then(response => {
        this.loading = false;
        this.rte = response.data.data.html
      })
    }
  }
}
</script>